document.addEventListener('teeinblue-event-component-injected', function() {
  const productGallery = document.getElementById("product-gallery");

  if (productGallery) {
    const wrapper = document.createElement("div");
    wrapper.id = "custom-sticky-teeinblue";

    while (productGallery.firstChild) {
      wrapper.prepend(productGallery.firstChild);
    }

    productGallery.prepend(wrapper);

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            wrapper.prepend(node);
          }
        });
      });
    });

    observer.observe(productGallery, { childList: true, subtree: false });
  }
})

document.addEventListener('teeinblue-event-after-cart-added', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
        fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(res => drawer.renderContents({sections: res}));
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }
});